module.exports = __webpack_public_path__ + "img/744.23527da9.jpg";